import React, { useState } from 'react';
import { useLock } from '../context/LockContext';
import { Lock } from 'lucide-react';

/**
 * LockScreen
 * حاجز بصري كامل الشاشة يظهر فوق أي محتوى حالي (بما فيه فورم لم يُحفظ بعد)
 * دون أن يُفكك أي مكوّن تحته من الـ DOM — فبمجرد فتح القفل، يرجع المستخدم
 * لنفس الحالة بالضبط (نفس الفاتورة، نفس الحقول المعبّأة).
 */
const LockScreen = () => {
    const { isLocked, unlock, unlockError, isUnlocking } = useLock();
    const [password, setPassword] = useState('');

    if (!isLocked) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        const success = await unlock(password);
        if (success) {
            setPassword('');
        }
    };

    const email = localStorage.getItem('admin_email') || '';

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 99999,
                backgroundColor: 'rgba(11, 31, 69, 0.85)',
                backdropFilter: 'blur(8px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <div
                style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '20px',
                    padding: '40px',
                    width: '360px',
                    maxWidth: '90vw',
                    textAlign: 'center',
                    boxShadow: '0 30px 60px rgba(0,0,0,0.3)',
                }}
            >
                <div
                    style={{
                        width: '56px',
                        height: '56px',
                        borderRadius: '50%',
                        backgroundColor: '#F2B705',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 16px auto',
                    }}
                >
                    <Lock size={26} color="#0B1F45" />
                </div>

                <h3 style={{ margin: '0 0 6px 0', color: '#0B1F45' }}>الجلسة مقفلة</h3>
                <p style={{ fontSize: '13px', color: '#5B6B95', marginBottom: '20px' }}>
                    {email ? `أدخل كلمة المرور لـ (${email}) لمتابعة عملك` : 'أدخل كلمة المرور لمتابعة عملك'}
                </p>

                <form onSubmit={handleSubmit}>
                    <input
                        type="password"
                        autoFocus
                        placeholder="كلمة المرور"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={{
                            width: '100%',
                            padding: '14px 16px',
                            borderRadius: '12px',
                            border: '1.5px solid #DCE3F4',
                            marginBottom: '12px',
                            fontSize: '14px',
                            boxSizing: 'border-box',
                            outline: 'none',
                        }}
                        required
                    />

                    {unlockError && (
                        <p style={{ color: '#e74c3c', fontSize: '12px', marginBottom: '12px' }}>
                            {unlockError}
                        </p>
                    )}

                    <button
                        type="submit"
                        disabled={isUnlocking}
                        style={{
                            width: '100%',
                            padding: '14px',
                            borderRadius: '12px',
                            border: 'none',
                            backgroundColor: '#F2B705',
                            color: '#0B1F45',
                            fontWeight: 700,
                            cursor: isUnlocking ? 'not-allowed' : 'pointer',
                            opacity: isUnlocking ? 0.7 : 1,
                        }}
                    >
                        {isUnlocking ? 'جاري التحقق...' : 'فتح القفل'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LockScreen;